import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { filter, map, Observable } from 'rxjs';

import { LoadingStatus } from '../../core/domain/events/state_provider';
import { DietitianCommands } from '../../data/dietitian/domain/dietitian_commands';
import { PatientStateProvider } from '../../data/patient/domain/patient_state_provider';

@Injectable()
export class MyGuard implements CanActivate {
  constructor(
    private router: Router,
    private patientStateProvider: PatientStateProvider,
    private dietitianCommands: DietitianCommands,
  ) {
    // nada
  }

  canActivate():
    | boolean
    | UrlTree
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree> {
    return this.patientStateProvider.state$
      .pipe(
        filter((s) => s.loading != LoadingStatus.LOADING), // ignore loading
      )
      .pipe(
        map((e) => {
          // if not signed as patient, redirect to auth
          if (!e.entity) {
            return this.router.createUrlTree(['/auth', 'my']);
          }

          this.dietitianCommands.loadDietitianOfCurrentUser().then();

          return true;
        }),
      );
  }
}
